import { Slot } from '@radix-ui/react-slot';
import React, { useId } from 'react';

import { textStyles } from './TextStyles';
import { Box } from './box';
import { cn } from './cn';

interface InputLabelProps
  extends Omit<React.HTMLProps<HTMLLabelElement>, 'label'> {
  label: React.ReactNode;
}

export const InputLabel = React.forwardRef<HTMLLabelElement, InputLabelProps>(
  ({ children, className, label, ...props }, ref) => {
    const id = useId();

    return (
      <Box vStack fullWidth>
        <label
          {...props}
          ref={ref}
          className={textStyles.caption({
            className: cn('flex flex-col gap-2', className),
            color: 'supporting',
            size: 'md',
            weight: 'bold',
          })}
          htmlFor={id}
        >
          {label}
        </label>
        <Slot id={id}>{children}</Slot>
      </Box>
    );
  },
);
